import { AccountAddressField } from "src/api/api-types/accounts"

export const isAccountDataChanged = (address1: Partial<AccountAddressField>, address2: Partial<AccountAddressField> ) => {
	return address1.addressLine1 !== address2.addressLine1
	|| address1.addressLine2 !== address2.addressLine2
	|| address1.city !== address2.city
	|| address1.state !== address2.state
	|| address1.zipCode !== address2.zipCode
}